//this is just for hack solution in gametrax
class GTAds{

	constructor(fsAds){

		this.fsAds = fsAds;
		console.log("GTads start");
		this.timerCount = 100;
		this.GTTimer = undefined;

		this.startTimer();
	}

	startTimer(){
		this.GTTimer = window.setInterval(this.parseAd.bind(this),500);
	}

	parseAd(){
		this.timerCount--;

        if(this.timerCount == -1){
            window.clearInterval(this.GTTimer);
            console.log('ADS - cannot find gametrax right rail ad');
        }else{
            console.log('ADS - retry ad parse');
            var checkEL = document.getElementById('nflgt-square-ad') || false;
            //when ad element is found
            checkEL && this.renderAdAndClear(checkEL);
        }
	}

	renderAdAndClear(el){

        window.clearInterval(this.GTTimer);

        this.fsAds.renderSlotByEl(el);
        this.fsAds.elementsForScroll.push(el);

    }

}

export default GTAds;


// WEBPACK FOOTER //
// ./assets/components/ads/GTAds.js